// v3 split-test only — de-emphasize the one-time (non-subscriber) purchase.
// When the Subscribe & Save toggle is OFF, this rewrites the buy-box so the
// one-time option reads as no special deal:
//   - tier headlines  -> "2 boxes" / "3 boxes" (no "Buy X, Get Y Free")
//   - strike-through compare-at price hidden
//   - promo line: drop "Save $X"; 2-box tier also drops the 90-day guarantee
//   - sub line: true box count at the flat single-box rate ($1.17/tablet)
//   - block header  -> "Select Your Supply"
//   - subheading    -> "Subscribers get up to two free boxes"
//   - MOST POPULAR / BEST VALUE badges hidden
// Subscribe ON restores every default (and leaves price/sub/per-day to bp-pdp.js).
//
// Loaded ONLY on the v3 product template (gated by template.suffix in
// sections/bp-offer-cards-v2-cart.liquid) so the live v2 cart/LP is untouched.
//
// bp-pdp.js recomputes .tier-sub and the per-day subheading on every tier click
// and toggle change, so we re-apply after any of its mutations via a guarded
// MutationObserver — our one-time state always wins.
(function () {
  'use strict';
  if (window.__HY_V3_OTP_LABELS__) return;
  window.__HY_V3_OTP_LABELS__ = true;

  var OTP = { '5mo': '3 Boxes', '3mo': '2 Boxes' };
  var OTP_SUB = { '5mo': '90 tablets · $1.17/tablet', '3mo': '60 tablets · $1.17/tablet' };
  var HEAD_OTP = 'Select Your Supply';
  var SUBHEAD_OTP = 'Subscribers get up to 52% off';
  var TOGGLE_OTP = 'Subscribe & Get Up to 2 Free Boxes';
  // Sticky cart should name the PRODUCT, not the selected offer. bp-pdp.js
  // rewrites [data-bp-sticky-label] to "Hydronate · <tier label>" on every
  // tier click; we force it back to the product name in apply().
  var STICKY_NAME = 'Hydronate Cholesterol Support';

  // One-time (non-subscriber) cart routing. When Subscribe & Save is OFF, the
  // buy box adds a SEPARATE full-price product (Shopify product 9412258332885,
  // tagged "no free boxes OTP") instead of the subscription product. Keyed by
  // tier id; these variants carry NO selling plan (clean one-time purchase).
  var OTP_VARIANT = {
    '1mo': '54033210245333', // 1 Box   — $34.99
    '3mo': '54033210278101', // 2 Boxes — $69.98
    '5mo': '54033210310869'  // 3 Boxes — $104.97
  };

  var applying = false;
  var observer = null;

  function form() { return document.querySelector('#bp-pdp-form'); }

  function apply() {
    var root = form();
    if (!root) return;
    var toggle = root.querySelector('[data-bp-sub-toggle]');
    var subbed = toggle ? toggle.checked : true;

    Array.prototype.forEach.call(root.querySelectorAll('[data-bp-tier]'), function (tier) {
      var id = tier.getAttribute('data-bp-tier');

      // Headline label.
      var nameEl = tier.querySelector('.tier-name');
      if (nameEl) {
        if (!nameEl.hasAttribute('data-hy-orig')) {
          nameEl.setAttribute('data-hy-orig', nameEl.textContent.trim());
        }
        var orig = nameEl.getAttribute('data-hy-orig');
        nameEl.textContent = (!subbed && OTP[id]) ? OTP[id] : orig;
      }

      // Strike-through (compare-at) price: subscribed only.
      var wasEl = tier.querySelector('.tier-price-was');
      if (wasEl) wasEl.style.display = subbed ? '' : 'none';

      // Promo line.
      var promoEl = tier.querySelector('.tier-promo');
      if (promoEl) {
        if (!promoEl.hasAttribute('data-hy-promo-orig')) {
          promoEl.setAttribute('data-hy-promo-orig', promoEl.textContent);
        }
        var po = promoEl.getAttribute('data-hy-promo-orig');
        if (subbed) {
          promoEl.style.display = '';
          promoEl.textContent = po;
        } else {
          // One-time: no savings claim. Drop any "Save $X" segment
          // (with or without a leading separator).
          var t = po.replace(/\s*[·•]?\s*Save\b[^·•]*/i, '');
          // If nothing but the ✓ check / whitespace remains, hide the line.
          if (!/[a-z0-9]/i.test(t.replace(/✓/g, ''))) {
            promoEl.style.display = 'none';
          } else {
            promoEl.style.display = '';
            promoEl.textContent = t;
          }
        }
      }

      // Sub line: one-time shows true box count at the single-box rate.
      // Subscribed is left for bp-pdp.js to recompute.
      if (!subbed && OTP_SUB[id]) {
        var subEl = tier.querySelector('.tier-sub');
        if (subEl) subEl.textContent = OTP_SUB[id];
      }

      // Badge (MOST POPULAR / BEST VALUE): subscribed only.
      var badge = tier.querySelector('.tier-badge');
      if (badge) badge.style.display = subbed ? '' : 'none';
    });

    // Buy-box header ("Buy More, Save More").
    var headEl = root.querySelector('.tier-block-head > span:first-child');
    if (headEl) {
      if (!headEl.hasAttribute('data-hy-orig')) {
        headEl.setAttribute('data-hy-orig', headEl.textContent);
      }
      headEl.textContent = subbed ? headEl.getAttribute('data-hy-orig') : HEAD_OTP;
    }

    // Buy-box subheading (per-day area). One-time only; subscribed left to bp-pdp.js.
    if (!subbed) {
      var perDayEl = root.querySelector('.tier-block-head [data-bp-per-day]');
      if (perDayEl) perDayEl.textContent = SUBHEAD_OTP;
    }

    // Subscribe toggle label: pitch the free boxes in both states (subscribed + one-time).
    var toggleLabel = root.querySelector('.sub-toggle-label strong');
    if (toggleLabel && toggleLabel.textContent !== TOGGLE_OTP) {
      toggleLabel.textContent = TOGGLE_OTP;
    }

    // Sticky cart line: keep the product name, never the selected offer label.
    // The element lives outside #bp-pdp-form, but bp-pdp.js updates it on the
    // same tier-click that mutates the form, so our observer re-runs apply()
    // right after and wins. (Querying document, not root, since it's outside.)
    var stickyLabel = document.querySelector('[data-bp-sticky-label]');
    if (stickyLabel && stickyLabel.textContent !== STICKY_NAME) {
      stickyLabel.textContent = STICKY_NAME;
    }

    // ── Cart variant routing (the actual one-time product wiring) ──────
    // Subscribe ON  → subscription product variant (bp-pdp's selectTier set it
    //                 on input[name=id]; we leave/restore it).
    // Subscribe OFF → the separate full-price OTP product variant.
    // Both add paths — bp-pdp's submit handler AND the cart drawer's
    // capture-phase submit interceptor — read #bp-pdp-form input[name="id"],
    // so overriding it here routes BOTH. bp-pdp omits the selling plan when
    // unsubscribed and the OTP product has none, so the add stays clean.
    // We must also RESTORE the subscription variant when subscribed: toggling
    // the switch does not re-run selectTier, so a prior one-time state could
    // otherwise leave an OTP variant (which has no plan) paired with a plan.
    var idInput = root.querySelector('input[name="id"]');
    var activeTier = root.querySelector('[data-bp-tier].is-active');
    if (idInput && activeTier) {
      var tid = activeTier.getAttribute('data-bp-tier');
      if (!subbed && OTP_VARIANT[tid]) {
        if (idInput.value !== OTP_VARIANT[tid]) idInput.value = OTP_VARIANT[tid];
      } else {
        var subVar = activeTier.getAttribute('data-bp-variant-id');
        if (subVar && idInput.value !== subVar) idInput.value = subVar;
      }
    }

    // Guarantee line under the Add to Cart button (both states, inserted once).
    if (!root.querySelector('[data-hy-guarantee]')) {
      var cta = root.querySelector('[data-bp-cta]') || root.querySelector('button[type="submit"]');
      if (cta) {
        var g = document.createElement('div');
        g.setAttribute('data-hy-guarantee', '');
        g.textContent = '90-Day Money-Back Guarantee';
        g.style.cssText = 'text-align:center;margin-top:12px;font-size:13px;font-weight:500;color:#6B7280;font-family:Instrument Sans;';
        cta.insertAdjacentElement('afterend', g);

        var fs = document.createElement('div');
        fs.setAttribute('data-hy-freeship', '');
        fs.textContent = 'Free Shipping Over $55';
        fs.style.cssText = 'text-align:center;margin-top:4px;font-size:13px;font-weight:500;color:#6B7280;font-family:Instrument Sans;';
        g.insertAdjacentElement('afterend', fs);
      }
    }
  }

  function safeApply() {
    if (applying) return;
    applying = true;
    if (observer) observer.disconnect();
    apply();
    var root = form();
    if (observer && root) observer.observe(root, { childList: true, subtree: true, characterData: true });
    applying = false;
  }

  function init() {
    var root = form();
    if (!root) return;
    observer = new MutationObserver(function () { safeApply(); });
    safeApply();
    var toggle = root.querySelector('[data-bp-sub-toggle]');
    if (toggle) toggle.addEventListener('change', safeApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
